import {Component} from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";


export class AutoCompleteItems extends Component {

  render() {
    const {
      label,
      options,
      defaultValue,
      onChanged,
    } = this.props;

    return (
        <div className="croField__autoCompleteItems">
          <Autocomplete
              fullWidth
              options={options}
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.name || "")}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              value={defaultValue || null}
              onChange={onChanged ? (_, value) => onChanged(value) : undefined}
              renderInput={(params) => (
                 <TextField
                     {...params}
                     label={label}
                     variant="standard"
                 />
              )}
          />
        </div>
    );
  }
}